import { FEEDBACK_LIMITS } from '@social-studio/shared';
import { api } from '../../lib/api';

export type FeedbackReport = { readonly message: string; readonly image?: string };
/** `limited` = too many reports (429), `unavailable` = hub down (502), `failed` = anything else. */
export type FeedbackResult = 'sent' | 'limited' | 'unavailable' | 'failed';

const viewport = () => `${window.innerWidth}x${window.innerHeight}${window.devicePixelRatio > 1 ? ` @${window.devicePixelRatio}x` : ''}`;

/** Sends one report to bennows (spec 05 section 6.1); the page it was sent from goes along. */
export async function sendFeedback(report: FeedbackReport): Promise<FeedbackResult> {
  try {
    const { response } = await api.POST('/v1/feedback', {
      body: {
        ...(report.message ? { message: report.message } : {}),
        ...(report.image ? { image: report.image } : {}),
        page_url: window.location.href.slice(0, FEEDBACK_LIMITS.pageUrlMaxLength),
        page_title: document.title.slice(0, FEEDBACK_LIMITS.pageTitleMaxLength),
        viewport: viewport().slice(0, FEEDBACK_LIMITS.viewportMaxLength),
      },
    });
    if (response.ok) return 'sent';
    if (response.status === 429) return 'limited';
    if (response.status === 502) return 'unavailable';
    return 'failed';
  } catch {
    return 'failed';
  }
}
